import PropTypes from 'prop-types'
import { GoogleLogin } from '@react-oauth/google'

import { sendError } from '@/utils/rollbar'

export default function GoogleLoginButton({ onSuccess }) {
  return (
    <GoogleLogin
      onSuccess={onSuccess}
      onError={errorResponse => sendError(errorResponse, 'Error signing in with Google')}
      width={280}
    />
  )
}

GoogleLoginButton.propTypes = {
  onSuccess: PropTypes.func.isRequired,
}
